import React from 'react'
import styles from './style.module.scss'
import UserListCell from '../../common/UserListCell'
import moreVerticalSVG from 'assets/images/more-vert-24.svg'
import checkGraySVG from 'assets/images/menu-check-gray-16.svg'
import { OmDropdownMenu, OmMenu, type OmMenuItem } from '@owma/kit'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { DECLINED } from '../../common/UserListCell'

interface FolderUserListCellProps {
  showMore?: boolean
  onChangePermission: (isReadOnly: boolean) => void
  onStopSharing: () => void
  email: string
  name?: string | null
  status: number
  nameSuffix?: any
  isReadOnly?: boolean
}
const FolderUserListCell: React.FC<FolderUserListCellProps> = ({
  showMore = false,
  onChangePermission,
  onStopSharing,
  ...userProps
}) => {
  const { t } = useTranslation()
  const items: OmMenuItem[] =
    userProps.status === DECLINED
      ? [
          {
            key: 're-share',
            label: t('calendar.share.reShare'),
            onClick: () => {
              onChangePermission(userProps.isReadOnly)
            },
          },
          {
            type: 'divider',
          },
          {
            key: 'stop-sharing',
            label: t('common.button.delete'),
            onClick: () => onStopSharing(),
          },
        ]
      : [
          {
            key: 'view-only',
            label: (
              <div className={styles.menuItem}>
                <div className={styles.label}>{t('calendar.invitation.viewOnly')}</div>
                {userProps.isReadOnly && (
                  <img src={checkGraySVG} alt="check" className={styles.checkIcon} />
                )}
              </div>
            ),
            onClick: () => {
              if (!userProps.isReadOnly) {
                onChangePermission(true)
              }
            },
          },
          {
            key: 'view-edit',
            label: (
              <div className={styles.menuItem}>
                <div className={styles.label}>{t('calendar.invitation.viewEdit')}</div>
                {!userProps.isReadOnly && (
                  <img src={checkGraySVG} alt="check" className={styles.checkIcon} />
                )}
              </div>
            ),
            onClick: () => {
              if (userProps.isReadOnly) {
                onChangePermission(false)
              }
            },
          },
          {
            type: 'divider',
          },
          {
            key: 'stop-sharing',
            label: t('calendar.invitation.stopSharing'),
            onClick: () => onStopSharing(),
          },
        ]
  const editMenu = <OmMenu items={items} className={classNames(styles.contextMenu)} />

  return (
    <div className={styles.container}>
      <div className={styles.userCell}>
        <UserListCell {...userProps} />
      </div>
      {showMore && (
        <OmDropdownMenu
          popupRender={() => editMenu}
          placement="bottomRight"
          trigger={['click']}
          overlayClassName={classNames('contextMenu', styles.moreDropdown)}
        >
          <button className={styles.moreButton}>
            <img src={moreVerticalSVG} alt="More" />
          </button>
        </OmDropdownMenu>
      )}
    </div>
  )
}

export default FolderUserListCell
